import { FC, SVGProps } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import Text from 'assets/images/logo-label.svg';
import Logo from 'assets/images/logo.svg';

const LogoComponent = Logo as unknown as FC<SVGProps<SVGSVGElement>>;
const TextComponent = Text as unknown as FC<SVGProps<SVGSVGElement>>;

const baseLogo = css`
    display: block;
    height: 100%;
    width: auto;
`;

export const LogoContainer = styled(Link)<{ height: number | undefined }>`
    display: flex;
    align-items: center;
    gap: 8px;
    height: ${({ height }) => (height ? `${height}px` : 'auto')};
`;

export const LogoImage = styled(LogoComponent)`
    ${baseLogo};
`;

export const LogoText = styled(TextComponent)`
    ${baseLogo};
    position: relative;
    top: 1px;
`;
